import ReactGA from 'react-ga4';

import apiClient from '@lib/apiClient';
import { CountryList, MessageWithText } from '@services/types';

import { ChatApiUrl } from './endpoints';
import { ImprovedPromptResponse, PromptToImprovePayload } from './types';

export const getImprovedPrompt = async (
    promptToImproveData: PromptToImprovePayload
): Promise<ImprovedPromptResponse> => {
    ReactGA.event({
        category: 'Api Request',
        action: 'Prompt Improvement',
    });
    const response = await apiClient.post<ImprovedPromptResponse>(
        ChatApiUrl.PromptImprovement,
        promptToImproveData
    );
    return response.data;
};

export const downloadChatHistory = async (chatHistory: Array<MessageWithText>): Promise<Blob> => {
    ReactGA.event({
        category: 'Api Request',
        action: 'Export chat to MS World',
    });
    const response = await apiClient.post<Blob>(ChatApiUrl.ExportChatToMSWorld, chatHistory, {
        responseType: 'blob',
    });
    return response.data;
};

export const getSupportedCountries = async (): Promise<CountryList> => {
    const response = await apiClient.get<CountryList>(ChatApiUrl.SupportedCountries);
    return response.data;
};
